module.exports = {
  // 生成表单
  templateDownload: '模板下载',
  // 生成表单
  generateForm: '生成表单',
  // 录入
  input: '录入',
  // 点击上传
  clickToUpload: '点击上传',
  // 选择用户
  selectUser: '选择用户',
  // 生成数据
  generateData: '生成数据',
  // 同步数据库
  synchronizeDatabase: '同步数据库',
  // 功能测试
  functionTest: '功能测试',
  // 配置地址
  configureAddress: '配置地址',
  // 权限控制
  accessControl: '权限控制',
  // 角色授权
  roleAuthorization: '角色授权',
  // 生成视图
  generateView: '生成视图',
  // 视图管理
  viewManagement: '视图管理',
  // 移除
  remove: '移除',
  // 更换
  replace: '更换',
  // JS增强
  jsEnhancement: 'JS增强',
  // SQL增强
  sqlEnhancement: 'SQL增强',
  // JAVA增强
  javaEnhancement: 'JAVA增强',
  // groovy增强
  groovyEnhancement: 'GROOVY增强',
  // 导入数据库表
  importDatabaseTable: '导入数据库表',
  // 代码生成
  codeGeneration: '代码生成',
  // 生成测试数据
  generateTestData: '生成测试数据',
  // 自定义按钮
  customButton: '自定义按钮',
  selectFile: '选择文件', // 选择文件
  executeImmediately: '立即执行', //立即执行
  zidianpeizhi: '字典配置', //字典配置
  confirm: '确定', // 确定
  search: '查询', // 查询
  reset: '重置', // 重置
  add: '新增', // 新增
  import: '导入', // 导入
  detailImport: '明细导入',//明细导入
  quickInput: '快读录入',//快读录入
  export: '导出', // 导出
  edit: '编辑', // 编辑
  more: '更多', // 更多
  delete: '删除', // 删除
  clear: '清空', // 清空
  batchOperation: '批量操作', // 批量操作
  cancel: '取消', // 取消
  details: '详情', // 详情
  password: '密码',//密码
  frozen: '冻结',//冻结
  thaw:'解冻',//解冻
  submit: '提交', // 提交
  writeOff: '冲销', // 冲销
  synchronize: '同步', // 同步
  print: '打印', // 打印
  save: '保存', // 保存
  close: '关闭', // 关闭
  select: '选择', // 选择
  addByReference: '参照新增', // 参照新增
  orderSelection: '选单', // 选单
  initializeImport: '初始化导入', // 初始化导入
  forDetailsPlease: '具体详情请', // 具体详情请
  clickToDownload: '点击下载', // 点击下载
  logOut: '退出登录', // 退出登录
  enable: '启用', // 启用
  disable: '禁用', // 禁用
  extractionCompanyDetails: '提取公司明细', // 提取明细
  addCompany: '添加公司', // 添加公司
  addSubordinate: '添加下级', // 添加下级
  releaseVersion: '发布版本', // 发布版本
  batchDelete: '批量删除', // 批量删除
  treeOperations: '树操作', // 树操作
  FatherSonConnection: '父子关联', // 父子关联
  cancelConnection: '取消关联', // 取消关联
  selectAll: '全部勾选', // 全部勾选
  unselectAll: '取消全选', // 取消全选
  expandAll: '展开所有', // 展开所有
  mergeAll: '合并所有', // 合并所有
  newRole: '新建角色', // 新建角色
  newDepartRole: '新建部门角色', // 新建部门角色
  clearSelection: '清空选择', // 清空选择
  batchRestore: '批量还原', // 批量还原
  restoreUser: '还原用户',// 还原用户
  deleteCompletely: '彻底删除',// 彻底删除
  existingUsers: '已有用户', // 已有用户
  authorization: '授权', // 授权
  saveOnly: '仅保存',// 仅保存
  saveAndClose: '保存并关闭',// 保存并关闭
  dataRules: '数据规则', // 数据规则
  approve: '审批',//审批
  turnDown: '驳回',//驳回
  void: '作废',//作废
  approval: '审批',//审批
  voided: '作废',//作废
  copy: '复制',//复制
  rejected: '驳回',//驳回
  reviewApproved: '审核通过',//审核通过
  sync: '同步',//同步
  update: '更新',//更新
  withdraw: '撤回',//撤回
  synchronousUpdate: '同步更新',//同步更新
  statistics: '统计',//统计
  drawDownContractPriceList: '提取合同价格清单',//提取合同价格清单
  newFarm: '新增养殖场',//新增养殖场
  detailImport: '明细导入',//明细导入
  refreshTheCache: '刷新缓存',//刷新缓存
  recycleBin: '回收站',//回收站
  customQuery: '高级查询',//高级查询
  notice: '通知',//通知
  systemMessage: '系统消息',//系统消息
  seeMore: '查看更多',//查看更多
  next: '下一步',//下一步
  previous: '上一步',//上一步
  release: '发布',//发布
  revoke: '撤销',//撤销
  see: '查看'//查看
}